import * as React from "react";
import { Component, ReactNode } from "react";
import { trackEvent } from "~/common/audit/trackEvent";
import * as styles from "./Confirmation.less";
import { ModalPopup, ModalPopupProps } from "./modalPopup";

export type ConfirmationWrapperProps = {
    cancel?: () => void;
    hideCancelButton?: boolean;
    title: string;
    description: string | ReactNode;
    auditShownEvent?: string;
    wrapperClassName?: string;
    isLoading?: boolean;
} & Pick<
    ModalPopupProps,
    "wrappedTitle" | "cross" | "theme" | "blockForFullStory" | "containerClass" | "width" | "minWidth" | "close"
> /*auto add ellipsis for the long title*/;

export class ConfirmationWrapper extends Component<ConfirmationWrapperProps> {
    static defaultProps: Partial<ConfirmationWrapperProps> = {
        width: 500,
    };

    constructor(props: ConfirmationWrapperProps) {
        super(props);
    }

    componentDidMount() {
        trackEvent(this.props.auditShownEvent);
    }

    render() {
        const {
            cancel,
            title,
            description,
            width,
            minWidth,
            wrapperClassName,
            isLoading,
            wrappedTitle,
            children,
            containerClass,
            close = cancel,
            ...props
        } = this.props;
        const cross = this.props.cross || !!cancel;

        return (
            <ModalPopup
                {...props}
                cross={cross}
                title={title}
                close={close}
                width={width}
                minWidth={minWidth}
                wrapperClassName={wrapperClassName}
                containerClass={containerClass}
                isLoading={isLoading}
                wrappedTitle={wrappedTitle}
            >
                <div className={styles.description}>{description}</div>
                <div className={styles.buttons}>{children}</div>
            </ModalPopup>
        );
    }
}
